import { SegmentedButtons, TextField, Typography } from '@scale/scaleui';
import React from 'react';
import { ChatBulkAuditObjectType } from '@scale/genai-compass-shared/cards/chat_bulk_audit';

export interface ChatBulkAuditCreationCompassProps {
  projectId: string | undefined;
  setProjectId: (projectId: string) => void;
  auditName: string;
  setAuditName: (auditName: string) => void;
  shouldClaimTasks: boolean;
  setShouldClaimTasks: (shouldClaimTasks: boolean) => void;
  limit: number | undefined;
  setLimit: (limit: number) => void;
  selectedObjectType: ChatBulkAuditObjectType | undefined;
}

function ChatBulkAuditCreationCompass({
  projectId,
  setProjectId,
  auditName,
  setAuditName,
  shouldClaimTasks,
  setShouldClaimTasks,
  limit,
  setLimit,
  selectedObjectType,
}: ChatBulkAuditCreationCompassProps) {
  return (
    <>
      <div className="h-full flex flex-col space-y-6">
        <div className="flex-1 space-y-4">
          <Typography.Subtitle3>Audit batch name</Typography.Subtitle3>
          <TextField
            className="w-full"
            value={auditName}
            onChange={e => setAuditName(e.target.value)}
          />
          <Typography.Subtitle3>Project ID</Typography.Subtitle3>
          <TextField
            className="w-full"
            value={projectId}
            onChange={e => setProjectId(e.target.value)}
          />
        </div>
        {selectedObjectType === ChatBulkAuditObjectType.WORKER && (
          <div className="flex-1 space-y-4">
            <Typography.Subtitle3>Task attempt limit per contributor</Typography.Subtitle3>
            <Typography.Caption>
              The most recent N task attempts for each contributor will be used to create the audit.
              (max 10)
            </Typography.Caption>
            <TextField
              className="w-full"
              type="number"
              value={limit}
              min={1}
              max={10}
              onChange={e => {
                setLimit(Math.max(1, Math.min(10, Number(e.target.value))));
              }}
            />
          </div>
        )}
        <div className="flex flex-row items-center">
          <Typography.Subtitle3>Mode</Typography.Subtitle3>
          <div className="flex gap-4 mx-4">
            <SegmentedButtons
              buttons={[
                {
                  icon: ['far', 'check-circle'],
                  id: 'justAudit',
                  label: 'Just Audit',
                },
                {
                  icon: ['far', 'edit'],
                  id: 'auditAndEdit',
                  label: 'Audit and Edit',
                },
              ]}
              onSelect={id => setShouldClaimTasks(id === 'auditAndEdit')}
              selected={shouldClaimTasks ? 'auditAndEdit' : 'justAudit'}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ChatBulkAuditCreationCompass;
